var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKissmetrics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.328.162C30.807.145 21.3 9.15 20.67 20.653 8.895 21.163-.298 31.014.007 42.795s9.995 21.143 21.78 21.043h33.487A8.69 8.69 0 0 0 64 55.167V21.77C63.973 9.823 54.276.154 42.328.162zM19.034 54.294c-4.492-1.164-8.014-4.65-9.222-9.13-.107-.43-.177-.87-.2-1.313h9.432zm2.606.39V34.228h8.894v20.464zm20.827 0h-8.86V17.42h8.86zm12.087-1.865a1.86 1.86 0 0 1-1.844 1.886h-7.133V24.622h8.978z",
    fill: "#4651ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKissmetrics);
export default __webpack_public_path__ + "static/media/kissmetrics.f149510232eafe5d8422fe19931a6ad9.svg";
export { ForwardRef as ReactComponent };